import { render, staticRenderFns } from "./selectLocationHygienist.vue?vue&type=template&id=6b8838b6&scoped=true"
import script from "./selectLocationHygienist.vue?vue&type=script&lang=js"
export * from "./selectLocationHygienist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8838b6",
  null
  
)

export default component.exports